import { toast } from "react-toastify";

export const errorToast = (message: string) => {
    toast(<p style={{ wordBreak: "break-word" }}>{message}</p>, {
        type: "error",
    });
};

export const successToast = (message: string) => {
    toast(<p style={{ wordBreak: "break-word" }}>{message}</p>, {
        type: "success",
    });
};
